/**
 * Normalizes a date string from the backend.
 * Spring Boot / Java serializes LocalDateTime without timezone suffix.
 * e.g. "2026-06-23T10:30:00" — browser treats as local time causing 5.5h offset for IST users.
 * Appending 'Z' forces UTC interpretation.
 */
export function parseUTC(dateStr) {
  if (!dateStr) return null;
  if (dateStr.endsWith('Z') || dateStr.includes('+')) return new Date(dateStr);
  return new Date(dateStr + 'Z');
}

export function timeAgo(dateStr) {
  if (!dateStr) return '';
  const diff = Math.floor((Date.now() - parseUTC(dateStr).getTime()) / 1000);
  if (diff < 60)    return 'just now';
  if (diff < 3600)  return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export function fmtDate(dateStr) {
  if (!dateStr) return '—';
  return parseUTC(dateStr).toLocaleDateString('en-IN', {
    day: 'numeric', month: 'short', year: 'numeric'
  });
}

export function fmtDateTime(dateStr) {
  if (!dateStr) return '—';
  return parseUTC(dateStr).toLocaleString('en-IN', {
    day: 'numeric', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
}

/**
 * datetime-local input is in the user's local timezone.
 * Backend stores LocalDateTime in UTC (JVM timezone).
 */
export function localInputToUtcDatetime(isoLocal) {
  if (!isoLocal) return null;
  const d = new Date(isoLocal);
  if (isNaN(d.getTime())) return isoLocal;
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}T${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:00`;
}

/** API UTC datetime → value for datetime-local input (local wall clock). */
export function utcDatetimeToLocalInput(dateStr) {
  if (!dateStr) return '';
  const d = parseUTC(dateStr);
  if (!d || isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
